import { ChartPlugin } from '../../_types'
import BackwardForwardTimeSummary from './BackwardForwardTimeSummary/BackwardForwardTimeSummary'

const backwardForwardTimeSummaryPlugin: ChartPlugin<'direction' | 'running' | "M28Running"> = {
  measures: [
    {
      slug: 'running',
      id: 'BS_RUN',
      representation: null,
    },
    {
      slug: 'direction',
      id: 'BS_DIR',
      representation: null,
    },
    {
      // TODO: remove `M28` asset binding and manage a general `runningReferenceAsset`
      slug: 'M28Running',
      assetId: "IBSGNMRQMBLXERXJ",
      id: 'BS_RUN',
      representation: null,
    }
  ],
  Component: BackwardForwardTimeSummary,
}

export default backwardForwardTimeSummaryPlugin
